import {Mapper} from '../../../../core/abstracts/mapper.abstract';
import {Page, PageableResponse} from '../../../../core/models/page-response.model';
import {StorageResponse} from '../model/storage-response.model';
import {VehicleStorage} from '../model/storage.model';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class StoragePageableResponseMapper extends Mapper<PageableResponse<StorageResponse>, Page<VehicleStorage>> {

  map(source: PageableResponse<StorageResponse>): Page<VehicleStorage> {
    const mappedContent = source.content.map(
      response => new VehicleStorage(response.id, response.name, response.address)
    );

    return Page.fromPaginationResponse<VehicleStorage>({
      ...source,
      content: mappedContent
    });
  }
}
